import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findAllRoom () {
    return axios.post(global.CMS_BASE + '/room/findAllRoom')
  },
  roomUpdate (params) {
    return axios.post(global.CMS_BASE + '/room/updateRoom', params)
  },
  roomDelete (params) {
    return axios.post(global.CMS_BASE + '/room/deleteRoom', params)
  },
  roomSalesManDelete (params) {
    return axios.post(global.CMS_BASE + '/room/deleteRoomSalesman', params)
  },
  roomInsert (params) {
    return axios.post(global.CMS_BASE + '/room/insertRoom', params)
  },
  findRoomHall () {
    return axios.post(global.CMS_BASE + '/room/findAllRoom', {data: {status: 40}, pageIndex: 0, pageSize: 10})
  },
  roomHallUpdate (params) {
    return axios.post(global.CMS_BASE + '/room/updateRoom', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/cms/roomList.js